import { RootState } from '../../config/hooks';

export const getOrderHistory = (state: RootState) =>
  state.orderFormHistoryReducer;
